export default {
    clean(date) {
        if ( date ) {
            return date.replaceAll("[UTC]", "")
        } else return null
    }
}